/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import encode from "@/common/function/encode";
import getLoginPasswordInfo from "@/common/function/getLoginPasswordInfo";
import { GeneralPropsType } from "@/common/types";
import useUpdateMission from "@/hook/useUpdateMission";
import checkIPService from "@/services/checkIPService";
import getContractHistory from "@/services/getContractHistory";
import getCookieService from "@/services/getCookieService";
import getCouponService from "@/services/getCouponService";
import getIPService from "@/services/getIPService";
import getNft from "@/services/getNft";
import getRankInterestAvailable from "@/services/getRankInterestAvailable";
import getRankInterestReward from "@/services/getRankInterestReward";
import getUnsignedSignature from "@/services/getUnsignedSignature";
import getUserInfo from "@/services/getUserInfo";
import loginAPPService from "@/services/loginAPPService";
import logoutService from "@/services/logoutService";
import updateUserInfoService, { PASSCODE_STATUS } from "@/services/updateUserInfo";
import { AmbassadorAvailable, AmbassadorReward } from "@/types/reward";
import { StartAppParams } from "@/types/startAppParams";
import generateIdFromString from "@/utils/generateIdFromString";
import { reverseBase64 } from "@/utils/generateToBase64";
import getHashFromObject from "@/utils/getHashFromObject";
import { getTeleId } from "@/utils/getTeleId";
import { Device } from "@capacitor/device";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { BiometryManager, initBiometryManager, initInitData, retrieveLaunchParams } from "@telegram-apps/sdk";
import { isTMA } from "@tma.js/sdk";
import { useParams, usePathname, useRouter } from "next/navigation";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useGlobalData } from "../GlobalData";
export interface LoginAppData {
  password?: string;
  isUseBiometry?: boolean;
}
export const AuthContext = createContext<any>(null);
function AuthProvider({
  children
}: GeneralPropsType) {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const {
    updateMissionData
  } = useUpdateMission();
  const [cookies, setCookie, removeCookie] = useCookies(["sessionCasdoor", "casdoor_session_id"]);
  const {
    setAffID,
    setIsAccessByAffLink,
    userInfo,
    setUserInfo,
    selectedFriend,
    contractHistory,
    setContractHistory,
    setUnsignedSignature,
    unsignedSignature,
    coupponsData,
    setCoupponsData,
    investRounds,
    setInvestRounds,
    nft,
    setNft,
    runEffectNavigation,
    setDeviceInfo,
    setIsUseBiometryForPinCode,
    setPersonalNft
  } = useGlobalData();
  const [walletAddress, setWalletAddress] = useState("");
  const [teleId, setTeleId] = useState<any>("");
  const [hash, setHash] = useState<any>("");
  const [startAppParamsState, setStartAppParamsState] = useState<string | undefined | StartAppParams>(undefined);
  const [token, setToken] = useState("");
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [isHaveAffParent, setIsHaveAffParent] = useState(false);
  const [bm, setBm] = useState<BiometryManager | null>(null);
  const [isUserUseFaceId, setIsUserUseFaceId] = useState<boolean>(true);
  const [isForgotPassword, setIsForgotPassword] = useState<boolean>(false);
  const [ambassadorAvailable, setAmbassadorAvailable] = useState<AmbassadorAvailable[] | undefined>(undefined);
  const [ambassadorReward, setAmbassadorReward] = useState<AmbassadorReward[] | undefined>(undefined);
  const [loginAppData, setLoginAppData] = useState<LoginAppData | null>(null);
  const [loginAppStep, setLoginAppStep] = useState<"login" | "forgot" | "auth-email" | "change-password" | "change-password-success" | "logged">("login");
  const [useBiometryFailed, setUseBiometryFailed] = useState<boolean>(false);
  const fullUrl = useRef("");
  useEffect(() => {
    fullUrl.current = window.location.href?.replace(window.location.origin, "");
  }, []);
  const nextNavigation = () => {
    router.push(fullUrl.current || "/");
  };
  const handleUnknownUserIsSubscribedAffV2 = async (telegramId: string, type: string, key: string, onRetrySuccess?: (data: any) => any, new_key?: boolean) => {
    try {
      const ip = await getIPService();
      const isNotAllowAccess = await checkIPService(ip);
      if (isNotAllowAccess) {
        router.push("/access-restricted");
        return;
      }
      const loginRes = await loginAPPService(telegramId, type, key, new_key);
      if (!loginRes) {
        return;
      }
      if (loginRes?.status === false) {
        localStorage.setItem("isWeb", "true");
        logoutService(type);
        removeCookie("sessionCasdoor");
        router.push("/callback-login-failed");
        return;
      }
      setToken(loginRes.access_token);
      setUserId(loginRes?.user_id);
      setUsername(loginRes?.username);
      setIsHaveAffParent(loginRes?.aff_status);
      localStorage.setItem("userIdLocal", loginRes?.user_id);
      if (loginRes?.aff_status) {
        // đã sub aff => lấy user token vào page home
        // when login with casdoor
        if (pathname.includes("/callback")) {
          return router.push("/");
        }
        if (startAppParamsState && typeof startAppParamsState !== "string" && startAppParamsState?.ic) {
          return router.push(`/${startAppParamsState?.np}?current_setting_tab=${startAppParamsState?.t}&isConnectedModal=${startAppParamsState?.im}&fromProvider=${startAppParamsState?.fp}`);
        }
        !onRetrySuccess && nextNavigation();
        console.log("🚀 ~ runWebFlow ~ pathname 1:", pathname);
        onRetrySuccess?.(loginRes);
        return loginRes;
      } else {
        // chưa sub aff => đưa đến màn sub affiliate
        // setAffID(affId);
        // router.push("/aff-Id");
        router.push("/onboard");
      }
      // if (!loginRes.newUser) {
      // }
    } catch (error) {
      console.log("🚀 ~ handleUnknownUserIsSubscribedAff ~ error:", error);
    }
  };
  const handleIf401 = async (err?: any, onReconnected?: (data?: any) => any) => {
    if (err?.status === 401) {
      await handleUnknownUserIsSubscribedAffV2(teleId, "telegram", hash || "");
      onReconnected?.();
    }
  };
  useEffect(() => {
    try {
      (async () => {
        const isCheckTele = await isTMA();
        if (!isCheckTele) {
          return;
        }
        const [biometryManager] = initBiometryManager();
        biometryManager.then(bmRes => {
          if (!!bmRes) {
            setBm(bmRes);
          }
        }).catch(err => {});
      })();
    } catch (err) {
      console.log("🚀 ~ useEffect ~ err:", err);
    }
  }, []);
  const requestAccessBiometry = async (onRejected?: (data?: any) => any) => {
    try {
      return await bm?.requestAccess({
        reason: "Authorize to start using biometry"
      }).then(accessGranted => {
        console.log("Access granted", accessGranted);
        if (!accessGranted) {
          const isRejectedBefore = localStorage.getItem("isRejectedBefore");
          if (isRejectedBefore == "true") {
            bm?.openSettings();
            return accessGranted;
          }
          localStorage.setItem("isRejectedBefore", "true");
        }
        return accessGranted;
      });
    } catch (error) {
      console.log("🚀 ~ requestAccessBiometry ~ error:", error);
    }
  };
  const updateBiometryToken = async () => {
    try {
      return await bm?.updateToken({
        token: "My token"
      }).then(status => {
        console.log("Token updated", status);
        return status;
      });
    } catch (error) {
      console.log("🚀 ~ updateBiometryToken ~ error:", error);
    }
  };
  const authenticatingBiometry = async (onPassed?: (data: any) => any, message?: string, onFailed?: (data?: any) => any) => {
    try {
      const isAllowed = await requestAccessBiometry();
      const isTokenUpdated = await updateBiometryToken();
      if (isAllowed && isTokenUpdated) {
        return await bm?.authenticate({
          reason: message || "Authorize to unlock the storage"
        }).then(token => {
          if (token) {
            onPassed?.(token);
            return true;
          } else {
            onFailed?.();
            return false;
          }
        });
      }
      return false;
    } catch (error) {
      console.log("🚀 ~ authenticatingBiometry ~ error:", error);
    }
  };
  const handleAuthBiometry = async () => {
    const auth = await authenticatingBiometry();
    if (!auth) {
      setLoginAppStep("login");
      setUseBiometryFailed(true);
    }
    if (auth) {
      setLoginAppStep("logged");
      setUseBiometryFailed(true);
    }
  };
  const handleSubmitSetPasswordMission = async () => {
    try {
      let loginData = await getLoginPasswordInfo();
      if (!loginData || !userInfo || userInfo?.passcode == PASSCODE_STATUS.ACTIVE) return;
      const res = await updateUserInfoService(token, {
        passcode: PASSCODE_STATUS.ACTIVE
      });
      if (res?.success) {
        setUserInfo({
          ...userInfo,
          passcode: PASSCODE_STATUS.ACTIVE
        });
        updateMissionData();
      }
      console.log("🚀 ~ handleSubmitSetPasswordMission ~ res:", res);
    } catch (error) {
      console.log("🚀 ~ handleSubmitSetPasswordMission ~ error:", error);
    }
  };
  const updateLoginAppData = async (newData?: LoginAppData) => {
    try {
      let loginData = await getLoginPasswordInfo();
      newData && (loginData = {
        ...loginData,
        ...newData
      });
      if (!!loginData) {
        const encodedData = await encode(loginData);
        localStorage.setItem("appConfig", encodedData);
        handleSubmitSetPasswordMission();
      }
      setLoginAppData(loginData);
      if (!loginData || !loginData?.password) {
        setLoginAppStep("logged");
      }
      return loginData;
    } catch (error) {
      console.log("🚀 ~ updateLoginAppData ~ error:", error);
    }
  };
  useEffect(() => {
    handleSubmitSetPasswordMission();
  }, [userInfo]);
  useEffect(() => {
    (async () => {
      if (!bm) return;
      if (!!loginAppData && loginAppData?.password && loginAppData?.isUseBiometry) {
        loginAppStep == "login" && handleAuthBiometry();
      }
    })();
  }, [bm, loginAppData]);
  useEffect(() => {
    updateLoginAppData();
  }, []);
  useEffect(() => {
    const localData = localStorage.getItem("isUseBiometryForPinCode");
    if (!localData) return;
    setIsUseBiometryForPinCode(!!localData);
  }, []);

  /**
   * Get ambassador data, unsigned signature, invest rounds, couppons data
   */
  useEffect(() => {
    if (token) {
      if (!!!ambassadorAvailable) {
        getRankInterestAvailable(token, data => {
          setAmbassadorAvailable(data?.data);
        });
      }
      if (!!!ambassadorReward) {
        getRankInterestReward(token, data => {
          setAmbassadorReward(data.data);
        });
      }
    }
  }, [ambassadorAvailable, ambassadorReward, token]);
  useEffect(() => {
    if (token && !!!nft) {
      getNft(token, data => {
        setNft(data.data?.systemNFT);
        setPersonalNft(data.data?.myNFT);
      });
    }
  }, [nft, token]);
  useEffect(() => {
    if (token && !!!unsignedSignature) {
      getUnsignedSignature(token, data => {
        setUnsignedSignature(data);
      });
    }
  }, [unsignedSignature, token]);
  useEffect(() => {
    if (token && !!!coupponsData) {
      getCouponService(token, (data: any) => {
        setCoupponsData(data?.coupons);
      });
    }
  }, [token, coupponsData]);
  // useEffect(() => {
  //     if (token && !!!investRounds) {
  //         getInvestRounds((data) => {
  //             setInvestRounds(data);
  //         });
  //     }
  // }, [token, investRounds]);

  /**
   * Get user info
   */
  useEffect(() => {
    if (token && !!!userInfo && isHaveAffParent) {
      getUserInfo(token, data => {
        console.log("🚀 ~ UserInfo ~ data:", data);
        setUserInfo(data);
      });
    }
  }, [token, userInfo, isHaveAffParent]);

  /**
   * Get contract history
   */
  useEffect(() => {
    if (token && !!!contractHistory) {
      getContractHistory(token, data => {
        setContractHistory(data);
      });
    }
  }, [token, contractHistory]);
  const getUserLogined = async (email: string) => {
    const idFromString = await generateIdFromString(email);
    return idFromString;
  };
  const getNewHashTelegram = () => {
    let initData, rawData;
    try {
      initData = initInitData();
      console.log("🚀 ~ runFlow ~ initData:", initData);
      rawData = retrieveLaunchParams();
      const hash = rawData?.initDataRaw;
      const telegramId = getTeleId(hash || "");
      return {
        hash,
        telegramId
      };
    } catch (error) {
      console.log("🚀 ~ runFlow ~ error:", error);
    }
  };
  useEffect(() => {
    try {
      const runFlow = async () => {
        const isTele = await isTMA();
        if (!isTele) return;
        let initData, rawData, startAppParams;
        try {
          initData = initInitData();
          console.log("🚀 ~ runFlow ~ initData:", initData);
          rawData = retrieveLaunchParams();
          startAppParams = reverseBase64(initData?.startParam?.replaceAll("_", "=") || "");
        } catch (error) {
          console.log("🚀 ~ runFlow ~ error:", error);
        }
        // let accountInfo: any = localStorage.getItem("accountInfo");
        let isReload: any = localStorage.getItem("isReload");
        setStartAppParamsState(startAppParams);
        const hash = rawData?.initDataRaw;
        const telegramId = getTeleId(hash || "");
        setHash(hash);
        !!hash && localStorage.setItem("teleHash", hash);
        // const telegramId = "6109576607";
        setTeleId(telegramId);
        const affIdFromUrl = initData?.startParam ?? "";
        setAffID(affIdFromUrl);
        !!affIdFromUrl && setIsAccessByAffLink(true);
        console.log("🚀 ~ useEffect ~ telegramId:", telegramId);
        console.log("🚀 ~ runWebFlow ~ startAppParams:", startAppParams, isReload, pathname);
        if (!telegramId) {
          // không có tele => báo lỗi hoặc return
          console.error("not found tele id");
          return;
        }
        // check user local
        const firstLogin = localStorage.getItem("firstLogin");
        if (!firstLogin) {
          handleUnknownUserIsSubscribedAffV2(telegramId, "telegram", hash || "");
          localStorage.setItem("firstLogin", "true");
          return;
        }
        localStorage.removeItem("isReload");
        handleUnknownUserIsSubscribedAffV2(telegramId, "telegram", hash || "");
        // if (accountInfo) {
        //     // Tiếp tục check

        //     const {
        //         access_token,
        //         refresh_token,
        //         aff_status,
        //         teleId,
        //         newUser,
        //         user_id,
        //         access_token_expires_in,
        //         username,
        //     } = JSON.parse(accountInfo);
        //     const currentTime = new Date().getTime();
        //     const expiredTime = access_token_expires_in * 1000 - currentTime;
        //     if (telegramId != teleId) {
        //         // user khác
        //         console.log("use khac");
        //         //clear thông tin user trước
        //         localStorage.removeItem("accountInfo");
        //         localStorage.removeItem("isReload");
        //         handleUnknownUserIsSubscribedAffV2(telegramId, "telegram", hash || "");
        //     } else {
        //         if (aff_status) {
        //             // đã sub aff => lấy user token vào page home
        //             if (access_token && expiredTime > 0) {
        //                 setToken(access_token);
        //                 setUserId(user_id);
        //                 setUsername(username);
        //                 setIsHaveAffParent(aff_status);

        //                 // handle when load page at setting page
        //                 if (startAppParams && typeof startAppParams !== "string" && startAppParams?.isCasdoor) {
        //                     if (isReload == "true") {
        //                         router.push(
        //                             pathname ??
        //                                 "/" + `?current_setting_tab=${startAppParams?.current_setting_tab}`
        //                         );
        //                         return;
        //                     } else {
        //                         router.push(
        //                             `/${startAppParams?.nextPage}?current_setting_tab=${startAppParams?.current_setting_tab}&isConnectedModal=${startAppParams?.isConnectedModal}&fromProvider=${startAppParams?.fromProvider}`
        //                         );
        //                         return;
        //                     }
        //                 }
        //                 localStorage.removeItem("isReload");
        //                 if (
        //                     (pathname.includes("gift-") || pathname.includes("share-coupon-result")) &&
        //                     !selectedFriend
        //                 ) {
        //                     return router.push("/");
        //                 }
        //                 router.push(pathname ?? "/");
        //                 console.log("🚀 ~ runFlow ~ pathname 2:", pathname);
        //                 return;
        //             } else {
        //                 // khong co user token
        //                 localStorage.removeItem("isReload");
        //                 handleUnknownUserIsSubscribedAffV2(telegramId, "telegram", hash || "");
        //             }
        //         } else {
        //             // chưa biết đã sub aff hay chưa => gọi api check
        //             localStorage.removeItem("isReload");
        //             handleUnknownUserIsSubscribedAffV2(telegramId, "telegram", hash || "");
        //         }
        //     }
        // } else {
        //     // chưa biết đã sub aff hay chưa => gọi api check
        //     localStorage.removeItem("isReload");
        //     handleUnknownUserIsSubscribedAffV2(telegramId, "telegram", hash || "");
        // }
      };
      runFlow();
    } catch (error) {
      console.log("🚀 ~ useEffect ~ error:", error);
    }
  }, []);
  useEffect(() => {
    router.prefetch("/portfolio");
  }, []);
  useEffect(() => {
    const timeDelay = 1500;
    if (pathname.includes("gift-sale") && !selectedFriend) {
      setTimeout(() => {
        router.push("/portfolio?current_portfolio_tab=gift_premium", {
          scroll: true
        });
      }, timeDelay);
    }
    // if (pathname.includes("gift-result") && !selectedFriend) {
    //     setTimeout(() => {
    //         router.push("/activity", {
    //             scroll: true,
    //         });
    //     }, timeDelay);
    // }
  }, [selectedFriend, pathname]);
  useEffect(() => {
    // Flow web login
    const runWebFlow = async () => {
      if (pathname == "/download") return;
      let isWeb: any = localStorage.getItem("isWeb");
      let accountInfo;
      try {
        accountInfo = await getCookieService("casdoor");
      } catch (error) {
        console.log("🚀 cookie:", error);
      }
      let casdoorDataJSON: any = localStorage.getItem("casdoorData");
      let isReload: any = localStorage.getItem("isReload");
      const casdoorData = casdoorDataJSON ? JSON.parse(casdoorDataJSON) : {};
      let startAppParams = {
        np: new URLSearchParams(window.location.search).get("nextPage") || "",
        ic: new URLSearchParams(window.location.search).get("isCasdoor") || "",
        t: new URLSearchParams(window.location.search).get("current_setting_tab") || "",
        im: new URLSearchParams(window.location.search).get("isConnectedModal") || "",
        fp: new URLSearchParams(window.location.search).get("fromProvider") || ""
      };
      console.log("🚀 ~ runWebFlow ~ startAppParams:", startAppParams, isReload, pathname);
      setStartAppParamsState(startAppParams);

      // link account not login
      if (!["/connect-socials", "/email-authen-redirect", "/callback", "/access-restricted"].includes(pathname)) {
        if (!cookies?.sessionCasdoor) {
          localStorage.setItem("ic", "true");
          localStorage.removeItem("accountInfo");
          localStorage.removeItem("casdoorData");
          localStorage.removeItem("isReload");
          localStorage.removeItem("userIdLocal");
          router.push("/auth/sign-in");
          return;
        }
        if (accountInfo) {
          const {
            access_token,
            aff_status,
            user_id,
            username
          } = accountInfo;
          setToken(access_token);
          setUserId(user_id);
          setUsername(username);
          setIsHaveAffParent(aff_status);
          localStorage.setItem("userIdLocal", user_id);
          if (!aff_status) {
            return router.push("/onboard");
          }
          if (startAppParams && typeof startAppParams !== "string" && startAppParams?.ic) {
            if (isReload == "true") {
              nextNavigation();
              return;
            }
            return router.push(`/${startAppParams?.np}?current_setting_tab=${startAppParams?.t}&isConnectedModal=${startAppParams?.im}&fromProvider=${startAppParams?.fp}`);
          }
          localStorage.removeItem("isReload");
          nextNavigation();
          console.log("🚀 ~ runWebFlow ~ pathname:", pathname);
        } else {
          removeCookie("sessionCasdoor");
          router.push("/auth/sign-in");
        }
      } else {
        if (cookies?.sessionCasdoor && pathname == "/callback" && !isWeb) {
          const currentTime = new Date().getTime();
          if (casdoorData) {
            const casdoorExpiredTime = casdoorData.expires_in * 1000 - currentTime;
            // casdoor expired
            if (casdoorExpiredTime < 0) {
              removeCookie("sessionCasdoor");
              router.push("/auth/sign-in");
              return;
            }
            const userID = await getUserLogined(casdoorData);
            const key = casdoorData.access_token || "";
            !!key && localStorage.setItem("teleHash", key);
            const provider = "casdoor";
            setTeleId(userID);
            const affIdFromUrl = params.affId || "";
            setAffID(affIdFromUrl);
            handleUnknownUserIsSubscribedAffV2(userID, provider, key, undefined, true);
            return;
          }
        }
      }
    };
    try {
      const initData = initInitData();
    } catch (error) {
      runWebFlow();
    }
  }, [cookies.sessionCasdoor]);
  useEffect(() => {
    const initialData = async () => {
      const isTele = await isTMA();
      if (isTele) return;
      if (pathname == "/setting") {
        let accountInfo;
        try {
          accountInfo = await getCookieService("casdoor");
        } catch (error) {
          console.log("getCookieService", error);
        }
        if (!accountInfo) {
          return;
        }
        // Tiếp tục check
        const {
          access_token,
          aff_status,
          user_id,
          username
        } = accountInfo;
        console.log("🚀 ~ initialData ~ access_token:", token);
        setToken(access_token);
        setUserId(user_id);
        setUsername(username);
        setIsHaveAffParent(aff_status);
        router.refresh();
      }
    };
    try {
      const initData = initInitData();
    } catch (error) {
      setTimeout(() => {
        initialData();
      }, 300);
    }
  }, [pathname]);
  useEffect(() => {
    const fpPromise = FingerprintJS.load();
    let deviceInfo: any;
    fpPromise.then(fp => {
      return fp.get();
    }).then(async result => {
      const components = result.components;
      const entropy = components;
      const confidence = result.confidence.score;
      const userAgent = window.navigator.userAgent;
      const hash = await getHashFromObject(components);
      deviceInfo = {
        entropy,
        confidence,
        userAgent,
        hash
      };
    }).finally(() => {
      Device.getInfo().then((result: any) => {
        deviceInfo = {
          ...deviceInfo,
          info: result
        };
        setDeviceInfo(deviceInfo);
      }).catch((err: any) => console.error("Error fetching device info:", err));
    });
  }, []);
  return <AuthContext.Provider value={{
    token,
    teleId,
    setToken,
    walletAddress,
    setWalletAddress,
    isHaveAffParent,
    setIsHaveAffParent,
    userId,
    requestAccessBiometry,
    updateBiometryToken,
    authenticatingBiometry,
    isUserUseFaceId,
    setIsUserUseFaceId,
    bm,
    getNewHashTelegram,
    handleUnknownUserIsSubscribedAffV2,
    ambassadorReward,
    ambassadorAvailable,
    setAmbassadorReward,
    setAmbassadorAvailable,
    handleIf401,
    hash,
    username,
    loginAppData,
    setLoginAppData,
    isForgotPassword,
    setIsForgotPassword,
    loginAppStep,
    setLoginAppStep,
    updateLoginAppData,
    useBiometryFailed
  }} data-sentry-element="unknown" data-sentry-component="AuthProvider" data-sentry-source-file="index.tsx">
            {children}
        </AuthContext.Provider>;
}
export default AuthProvider;
export const useAuth = () => {
  const context = useContext(AuthContext);
  return context ?? {};
};